import styled from 'styled-components';

const CallToActionStyles = styled.div`
  margin-top: 2rem;

  .box {
    padding: 2.5rem 1.5rem 3rem 1.5rem;
    border: 0.0625rem solid var(--color-swiss-coffee);
    text-align: center;
    background-color: var(--color-sand);
  }

  .heading {
    font-weight: var(--font-weight-medium);
    color: var(--color-bark);
  }

  .btn-group {
    margin-top: 2rem;
  }

  @media (min-width: 768px) {
    .box {
      max-width: 35rem;
      margin: 0 auto;
      padding: 3rem 1.5rem 3.5rem 1.5rem;
    }

    .heading,
    .text {
      max-width: 80%;
      margin-left: auto;
      margin-right: auto;
    }

    .heading {
      font-size: 1.3rem;
    }
  }

  @media (min-width: 1200px) {
    .box {
      max-width: 50rem;
    }

    .heading,
    .text {
      max-width: 80%;
    }

    .text {
      font-size: 1.2rem;
    }
  }
`;

export default CallToActionStyles;
